import type { FunctionComponent } from 'react';

import styles from './Details.module.less';

type Props = {
  heading: string;
};

/**
 * Simple way to do a DetailsSection (with the proper heeading/styling)
 * but allows you to pass whatever you want as the children.
 */
const DetailsSection: FunctionComponent<Props> = ({ heading, children }) => (
  <section className={styles.detailsSection}>
    <h3 className={styles.detailsSectionHeading}>
      {heading}
    </h3>
    {children}
  </section>
);

export default DetailsSection;
